module.exports = __webpack_public_path__ + "static/img/active_02.ee87961.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey2/images/activity/active_02.jpg
// module id = PrTW
// module chunks = 0